import { Button, Form, Input, message, Modal } from 'antd';
import axios from 'axios';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import getUserFromToken from '../../utils/getUserFromToken';

const ChangePassword = ({ visible, onCancel }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const userId = getUserFromToken();

  const handleLogout = () => {
    localStorage.clear();
    toast.success("Logged Out");
    localStorage.setItem("isLogged", "");
    window.location.href = "/admin/auth/login";
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await axios.post('/user/change-password', {
        userId,
        newPassword: values.newPassword,
      });

    //   const response = await changePassword({ userId: userId,  newPassword: values.newPassword });
      
      if (response.status === 200) {
        message.success('Password changed successfully');
        onCancel();
        // Update local storage to indicate password has been changed
        // localStorage.setItem('passwordChanged', 'true');
        handleLogout();
      }
    } catch (error) {
      message.error('Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Change Default Password"
      visible={visible}
      footer={null}
      closable={false}
      maskClosable={false}
    >
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Form.Item
          name="newPassword"
          label="New Password"
          rules={[
            { required: true, message: 'Please input your new password!' },
          ]}
        >
          <Input.Password />
        </Form.Item>
        
        <Form.Item
          name="confirmPassword"
          label="Confirm Password"
          dependencies={['newPassword']}
          rules={[
            { required: true, message: 'Please confirm your password!' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject('The two passwords do not match!');
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item className="text-right">
          <Button type="primary" htmlType="submit" loading={loading}>
            Change Password
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChangePassword;
